<script type="text/javascript">
	import Feature from "../../Branding/Feature"
	import ModelType from "../../Models/ModelType"
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Button, {Label} from '@smui/button';
	import List, {Group, Item, Graphic, Meta, Label as ListLabel, Separator, Subheader, Text, PrimaryText, SecondaryText} from '@smui/list';

	export let model;
	export let modelType; // ModelType.USER || ModelType.COMPANY;
	export let editable;

	let style = "width:100%;margin-top:10px;";

	let allFeatures = Feature.all();

	let selectedAllowFeatureOverride = "";
	let selectedDenyFeatureOverride = "";

	let canListThisAllowFeature = (feature) => {
		if (typeof editable.feature_overrides[feature] !== "undefined") {
			return false;
		}
		// can add
		if (modelType === ModelType.USER) {
			let hasFeature = (model.get("tier_features")[feature] === 1 || model.get("company_features")[feature] === 1) && model.get("company_features")[feature] !== -1;
			if (!hasFeature) {
				return true;
			}
		}
		else if (modelType === ModelType.COMPANY) {
			if (!model.get("tier_features")[feature]) {
				return true;
			}
		}
		return false;
	}
	let canListThisDenyFeature = (feature) => {
		if (typeof editable.feature_overrides[feature] !== "undefined") {
			return false;
		}
		// can remove
		if (modelType === ModelType.USER) {
			if (model.get("company_features")[feature] || model.get("tier_features")[feature]) {
				return true;
			}
		}
		else if (modelType === ModelType.COMPANY) {
			if (model.get("tier_features")[feature]) {
				return true;
			}
		}
		return false;
	}
	let addGiveFeatureOverride = () => {
		if (selectedAllowFeatureOverride === "") {
			return;
		}
		editable.feature_overrides[selectedAllowFeatureOverride] = 1;
		selectedAllowFeatureOverride = "";
		editable = editable;
	};
	let addTakeFeatureOverride = () => {
		if (selectedDenyFeatureOverride === "") {
			return;
		}
		editable.feature_overrides[selectedDenyFeatureOverride] = -1;
		selectedDenyFeatureOverride = "";
		editable = editable;
	};
	let removeFeatureOverride = (feature) => {
		delete editable.feature_overrides[feature];
		editable = editable;
	}

</script>

<h2>Features / Permissions Overrides</h2>

<DataTable table$aria-label="Features / Permissions Overrides" style={style}>
	<Head style="display: none">
		<Row>
			<Cell></Cell>
			<Cell></Cell>
		</Row>
	</Head>
	<Body>
		<Row>
			<Cell class='cell-align-top'>Overrides</Cell>
			<Cell>
				{#if Object.keys(editable.feature_overrides).length == 0}
					<p>No overrides set.</p>
				{:else}
					<List class="demo-list">
						{#each Object.keys(editable.feature_overrides) as key}
							<Item>
								<ListLabel>
									{#if editable.feature_overrides[key] === 1}
										<span style='color:green;'><b>{key}</b> feature access added.</span>
									{:else}
										<span style='color:red;'><b>{key}</b> feature access removed.</span>
									{/if}
								</ListLabel>
								<Meta>
									<button data-key={key} class='btn-sml bg-error' style={"margin-top:0px;font-size:12px;cursor:pointer;"} on:click={(e)=>{
										removeFeatureOverride(key);
									}}>Remove</button>
								</Meta>
							</Item>
						{/each}
					</List>
				{/if}
			</Cell>
		</Row>
		<Row>
			<Cell class='cell-align-top'>Allow</Cell>
			<Cell>
				<select class='default' bind:value={selectedAllowFeatureOverride} style={"width:80%;"}>
					<option value={""} selected={selectedAllowFeatureOverride == ""}>Please select</option>
					{#each allFeatures as feature}
						{#if canListThisAllowFeature(feature)}
							<option value={feature} selected={selectedAllowFeatureOverride === feature}>{feature}</option>
						{/if}
					{/each}
				</select>
				<Button color="primary" variant="unelevated" style={"width:19%;margin-left:1%;margin-top:-2px;"} on:click={addGiveFeatureOverride}><Label>Add</Label></Button>
			</Cell>
		</Row>
		<Row>
			<Cell class='cell-align-top'>Deny</Cell>
			<Cell>
				<select class='default' bind:value={selectedDenyFeatureOverride} style={"width:80%;"}>
					<option value={""} selected={selectedDenyFeatureOverride == ""}>Please select</option>
					{#each allFeatures as feature}
						{#if canListThisDenyFeature(feature)}
							<option value={feature} selected={selectedDenyFeatureOverride === feature}>{feature}</option>
						{/if}
					{/each}
				</select>
				<Button color="primary" variant="unelevated" style={"width:19%;margin-left:1%;margin-top:-2px;"} on:click={addTakeFeatureOverride}><Label>Add</Label></Button>
			</Cell>
		</Row>
	</Body>
</DataTable>
